import { render, staticRenderFns } from "./SurveyDataManagement.vue?vue&type=template&id=65c98880&"
import script from "./SurveyDataManagement.vue?vue&type=script&lang=ts&"
export * from "./SurveyDataManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports